/** Logs only in Vite dev — keeps production consoles quiet for MVP review. */
export function devLog(...args) {
  if (import.meta.env.DEV) console.log(...args);
}

export function devWarn(...args) {
  if (import.meta.env.DEV) console.warn(...args);
}
